import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  Divider,
} from "@mui/material";
import axios from "axios";
import { API_URL } from "../../../../Config/api";

const cancelby = [
  { value: 1, label: "Spero" },
  { value: 2, label: "Customer" },
];

const PackageAdminCancellation = ({ eventID,eveId, subSrvID, onClose, fetchPackages, sessionCount }) => {
  console.log(sessionCount, "sessionCountsessionCountsessionCount")
  const accessToken = localStorage.getItem("token");

  // States
  const [loading, setLoading] = useState(false);
  const [cancelReason, setCancelReason] = useState([]);
  const [selectedReasonID, setSelectedReasonID] = useState("");
  const [selectedCancelReason, setSelectedCancelReason] = useState("");
  const [remark, setRemark] = useState("");
  const [selectedOption, setSelectedOption] = useState(""); // Default: Service
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Fetch Reasons
  useEffect(() => {
    fetch(
      `${API_URL}/web/cancellation_reason_follow_up_list/${selectedReasonID || 1}`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )
      .then((res) => res.json())
      .then((data) => setCancelReason(data))
      .catch((err) => console.error(err));
  }, [accessToken, selectedReasonID]);

  const handleAction = async () => {

    const trimmedRemark = remark ? remark.trim() : "";

    if (!selectedReasonID || !selectedCancelReason) {
      setSnackbarMessage("Please select Cancellation By and Reason");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    if (trimmedRemark.length < 15) {
      setSnackbarMessage("Remark must be at least 15 characters long");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    if (selectedOption === "2" && (!fromDate || !toDate)) {
      setSnackbarMessage("Please select both dates for session cancellation");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    setLoading(true);

    const isSession = selectedOption === "2";
    const url = isSession
      ? `${API_URL}/packages/cancelsession/?eve_id=${eveId}`
      : `${API_URL}/packages/cancelevent/?eve_id=${eveId}`;

    const requestBody = {
      cancellation_by: parseInt(selectedReasonID),
      cancellation_reason: parseInt(selectedCancelReason),
      remark: trimmedRemark,
    };

    if (isSession) {
      requestBody.dates = [[fromDate, toDate]];
    }

    try {
      const response = await axios({
        method: "PUT",
        url: url,
        data: requestBody,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });


      setSnackbarMessage("Cancellation successful!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);


      setTimeout(() => {
        onClose();
        fetchPackages();
      }, 1000);
    } catch (err) {
      // Axios error handling
      const errorMsg =
        err.response?.data?.msg || err.message || "Something went wrong";
      setSnackbarMessage(errorMsg);
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
      <Typography
        variant="body2"
        sx={{ fontWeight: 600, color: "text.secondary" }}
      >
        Event ID: {eventID}
      </Typography>

      <TextField
        select
        fullWidth
        size="small"
        label="Package Cancellation Type"
        value={selectedOption}
        onChange={(e) => setSelectedOption(e.target.value)}
      >
        <MenuItem value="1">Service Cancellation</MenuItem>
        {sessionCount !== 1 && (
          <MenuItem value="2">Session Cancellation</MenuItem>
        )}
        {/* <MenuItem value="2">Session Cancellation</MenuItem> */}
      </TextField>

      <TextField
        select
        fullWidth
        size="small"
        label="PackageAdminCancellation By"
        value={selectedReasonID}
        onChange={(e) => setSelectedReasonID(e.target.value)}
      >
        {cancelby.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        fullWidth
        size="small"
        label="Cancellation Reason"
        value={selectedCancelReason}
        onChange={(e) => setSelectedCancelReason(e.target.value)} // Yahan ID store hogi
      >
        {cancelReason.map((opt) => (
          <MenuItem
            key={opt.cancelation_reason_id}
            value={opt.cancelation_reason_id}
          >
            {opt.cancelation_reason}
          </MenuItem>
        ))}
      </TextField>

      {selectedOption === "2" && (
        <Box sx={{ display: "flex", gap: 1 }}>
          <TextField
            type="date"
            fullWidth
            size="small"
            label="From"
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setFromDate(e.target.value)}
          />
          <TextField
            type="date"
            fullWidth
            size="small"
            label="To"
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setToDate(e.target.value)}
          />
        </Box>
      )}

      <TextField
        fullWidth
        multiline
        rows={3}
        label="Remark"
        placeholder="Please enter at least 15 characters..."
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
      />

      <Divider />

      <Button
        variant="contained"
        fullWidth
        disabled={loading}
        onClick={handleAction}
        sx={{
          backgroundColor: "rgb(52, 123, 137)",
          "&:hover": { backgroundColor: "rgb(40, 100, 110)" },
          py: 1.2,
        }}
      >
        {loading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Confirm Package Cancellation"
        )}
      </Button>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert severity={snackbarSeverity}>{snackbarMessage}</Alert>
      </Snackbar>
    </Box>
  );
};

export default PackageAdminCancellation;
